import { Comment } from "./Comment.js";
import { CommentForm } from "./CommentForm.js";
import "react";
import { Icon, Loading, Pagination } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdOutlineComment } from "react-icons/md";
//#region src/components/Comments/Comments.tsx
var Comments = ({ checkCanEditComment, comments, commentsPerPage, formPosition = "bottom", loading, onCommentsPerPageChange, onDelete, onEdit, onPageClick, onSubmit, skippedComments, totalComments }) => {
	if (!Array.isArray(comments) || !comments.length) {
		if (loading) return /* @__PURE__ */ jsx("div", {
			className: "mt-lg flex justify-center",
			children: /* @__PURE__ */ jsx(Loading, {
				message: "Loading Comments",
				messagePosition: "vertical",
				size: "lg"
			})
		});
		return /* @__PURE__ */ jsxs("div", {
			className: "mt-lg flex h-full grow flex-col items-center opacity-50",
			children: [/* @__PURE__ */ jsx(Icon, {
				Icon: MdOutlineComment,
				size: "xl",
				color: "neutral"
			}), /* @__PURE__ */ jsx("span", {
				className: "mt-xs text-center text-lg font-medium capitalize",
				children: "No comments"
			})]
		});
	}
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-y-xl relative flex flex-col",
		children: [
			loading && /* @__PURE__ */ jsx(Loading, {
				message: "Loading Comments",
				messagePosition: "vertical",
				overlay: true,
				size: "lg"
			}),
			!!onSubmit && formPosition === "top" && /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(CommentForm, { onSubmit }), /* @__PURE__ */ jsx("div", { className: "mt-base border-border border-t" })] }),
			comments.map((comment) => /* @__PURE__ */ jsx(Comment, {
				body: comment.body,
				checkCanEditComment: () => checkCanEditComment(comment),
				createdAt: comment.createdAt,
				createdByUser: comment.createdByUser,
				id: comment.id,
				fileUrls: comment.fileUrls,
				onEdit,
				onDelete: onDelete ? () => onDelete(comment) : void 0,
				title: comment.title
			}, comment.id)),
			/* @__PURE__ */ jsxs("div", { children: [!!onPageClick && /* @__PURE__ */ jsx(Pagination, {
				onPageClick,
				onSetRecordsPerPage: onCommentsPerPageChange,
				recordsPerPage: commentsPerPage,
				showDescription: true,
				skippedRecords: skippedComments || 0,
				totalRecords: totalComments || 0
			}), !!onSubmit && formPosition === "bottom" && /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", { className: "my-base border-border border-t" }), /* @__PURE__ */ jsx(CommentForm, { onSubmit })] })] })
		]
	});
};
//#endregion
export { Comments };

//# sourceMappingURL=Comments.js.map